export const DISCOUNT_CARD_ACTIONS = {
	CREATE: 'DISCOUNT_CARD_CREATE',
	VIEW: 'DISCOUNT_CARD_VIEW'
}
